import { Component, OnInit, ViewChild } from '@angular/core';
import {
	ProfessionalExperienceModalComponent, EducationModalComponent,
	ProfessionalCertificatesModalComponent, VoluntaryModalComponent,
	LanguageModalComponent, ReferencesModalComponent, InterestModalComponent
} from './modals';
import { NgbModal, NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { Observable, Subject, merge, OperatorFunction } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import { CountriesService, CitiesService, CompaniesService, CandidatesService, AuthService } from '../../services';
import { headers } from './headers';
import { FormBuilder, FormGroup } from "@angular/forms";
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';

@Component({
	selector: 'app-profile',
	templateUrl: './profile.component.html',
	styleUrls: ['./profile.component.scss']
})

export class ProfileComponent implements OnInit {
	@ViewChild('instance', { static: false }) instance: NgbTypeahead;
	@ViewChild('instanceRef', { static: false }) instanceRef: NgbTypeahead;
	@ViewChild('instanceAddRef', { static: false }) instanceAddRef: NgbTypeahead;
	currentUser = null;

	candidate: any = {
		first_name: null,
		father_name: null,
		third_name: null,
		last_name: null,
		mother_name: null,
		ar_first_name: null,
		ar_father_name: null,
		ar_third_name: null,
		ar_last_name: null,
		identity_id: null,
		gender: null,
		maritial_status: null,
		nationality: null,
		sec_nationality: null,
		birth_place: null,
		birth_date: null,
		identity_type: null,
		military_service: null,
		military_service_reason: null,
		is_albaraka_emp: null,
		notice_period: null,
		address_country: null,
		address_city: null,
		address_district: null,
		address_tel_1: null,
		address_tel_2: null,
		address_mob_1: null,
		address_mob_2: null,
		address_email: null,
		address_details: null,
		professional_experience: [],
		education: [],
		languages: [],
		professional_certificate: [],
		references: [],
		voluntary: [],
		vacancies: [],
		is_professional_experience: false,
		has_image: false
	}
	checkConfirm = false;
	img_file = "https://www.albaraka.com.sy/joinus/backend/public/images/profile-picture.jpg"
	candidate_image = null;
	countries = [];
	cities = [];
	companies = [];
	maxDate: Date = null;
	minDate: Date = null;

	companies$ = new Subject<any>();
	_headers = {};
	isLoading = false;
	isProfileLoading = false;
	isActivationLoading = false;
	isImageLoading = false;
	fileChanged = false;
	identity_maxlength = 11;
	identity_minlength = 5;
	viewVacancies = false;
	initLoading = false;
	//progress bar
	progressColor = "danger";
	level_note = "Present Your Self!";
	fill_level = 0;
	strength = "Beginner"
	activeIds = [];
	//beginner, intermediate, advanced, expert
	constructor(private modalService: NgbModal,
		private countryService: CountriesService,
		private cityService: CitiesService,
		private companyService: CompaniesService,
		private candidatesService: CandidatesService,
		private authService: AuthService,
		private toastr: ToastrService,
		private router: Router) {
		this._headers = headers;
		if (!this.authService.user)
			this.router.navigate(['login', { queryParams: 'user-profile' }]);
		if (this.router.url == "/user-profile/vacancies")
			this.viewVacancies = true
		this.authService.valueSource.subscribe(user => { this.currentUser = user; });
	}

	ngOnInit() {
		var currentTime = new Date()
		var month = currentTime.getMonth();
		var day = currentTime.getDate();
		var year = currentTime.getFullYear();
		this.initLoading = true;
		this.authService.getCandidateInfo().subscribe((res: any) => { this.currentUser = res.data; this.getCandidateInfo(); },
			(error) => { this.currentUser = null; },
			() => { this.authService.user = this.currentUser; console.log("here") }
		);

		this.maxDate = new Date(year - 18, month + 1, day);
		this.minDate = new Date(year - 100, month, day);

		this.countryService.getAll().subscribe((res: any) => { this.countries = res.data; });
		this.cityService.getAll().subscribe((res: any) => { this.cities = res.data; });
		this.companyService.getAll().subscribe((res: any) => { this.companies = res.data; });
	}

	addNewProfessionlExp() {
		const modalRef = this.modalService.open(ProfessionalExperienceModalComponent);
		modalRef.result.then((result) => {
		}).catch((error) => {
		});
		modalRef.componentInstance.notifyParent.subscribe((result) => {
			this.getCandidateInfo(true, "Add Professional Experience");
		})
	}

	addNewEducation() {
		const modalRef = this.modalService.open(EducationModalComponent);
		modalRef.result.then((result) => {

		}).catch((error) => {

		});
		modalRef.componentInstance.notifyParent.subscribe((result) => {
			this.getCandidateInfo(true, "Add Educatoin");
		})
	}

	addNewProfessionlCert() {
		const modalRef = this.modalService.open(ProfessionalCertificatesModalComponent);
		modalRef.result.then((result) => {

		}).catch((error) => {

		});
		modalRef.componentInstance.notifyParent.subscribe((result) => {
			this.getCandidateInfo(true, "Add Professional Certificate");
		})
	}

	addNewVoluntary() {
		const modalRef = this.modalService.open(VoluntaryModalComponent);
		modalRef.result.then((result) => {

		}).catch((error) => {

		});
		modalRef.componentInstance.notifyParent.subscribe((result) => {
			this.getCandidateInfo(true, "Add Voluntary Work");
		})
	}

	addNewLanguage() {
		const modalRef = this.modalService.open(LanguageModalComponent);
		modalRef.result.then((result) => {

		}).catch((error) => {

		});
		modalRef.componentInstance.selectedLanguages = this.candidate.languages.map(r => r.language_id);
		modalRef.componentInstance.notifyParent.subscribe((result) => {
			this.getCandidateInfo(true, "Add Language");
		})
	}

	addNewRefrence() {
		const modalRef = this.modalService.open(ReferencesModalComponent);
		modalRef.result.then((result) => {

		}).catch((error) => {

		});
		modalRef.componentInstance.notifyParent.subscribe((result) => {
			this.getCandidateInfo(true, "Add Reference");
		})
	}

	addNewInterest() {
		const modalRef = this.modalService.open(InterestModalComponent);
		modalRef.result.then((result) => {

		}).catch((error) => {

		});
		modalRef.componentInstance.notifyParent.subscribe((result) => {
			this.getCandidateInfo(true, "Add Field Interest");
		})
	}

	formatter = (country: any) => country.country_name_en;
	focus$ = new Subject<string>();
	click$ = new Subject<string>();
	search: OperatorFunction<string, readonly { id, country_name_en }[]> = (text$: Observable<string>) => {
		text$.pipe(debounceTime(200), distinctUntilChanged());
		const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
		const clicksWithClosedPopup$ = this.click$.pipe(filter(() => !this.instance.isPopupOpen()));
		const inputFocus$ = this.focus$;

		return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(map(term => (term === '' ? this.countries
			: this.countries.filter(country => new RegExp(term, 'mi').test(country.country_name_en)).slice(0, 10)))
		)
	}

	sec_focus$ = new Subject<string>();
	sec_click$ = new Subject<string>();
	sec_search: OperatorFunction<string, readonly { id, country_name_en }[]> = (text$: Observable<string>) => {
		text$.pipe(debounceTime(200), distinctUntilChanged());
		const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
		const clicksWithClosedPopup$ = this.sec_click$.pipe(filter(() => !this.instanceRef.isPopupOpen()));
		const inputFocus$ = this.sec_focus$;

		return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(map(term => (term === '' ? this.countries
			: this.countries.filter(country => new RegExp(term, 'mi').test(country.country_name_en)).slice(0, 10)))
		)
	}

	add_focus$ = new Subject<string>();
	add_click$ = new Subject<string>();
	add_search: OperatorFunction<string, readonly { id, country_name_en }[]> = (text$: Observable<string>) => {
		text$.pipe(debounceTime(200), distinctUntilChanged());
		const debouncedText$ = text$.pipe(debounceTime(200), distinctUntilChanged());
		const clicksWithClosedPopup$ = this.add_click$.pipe(filter(() => !this.instanceAddRef.isPopupOpen()));
		const inputFocus$ = this.add_focus$;

		return merge(debouncedText$, inputFocus$, clicksWithClosedPopup$).pipe(map(term => (term === '' ? this.countries
			: this.countries.filter(country => new RegExp(term, 'mi').test(country.country_name_en)).slice(0, 10)))
		)
	}

	updateUserProfile(type) {
		let x = `${this.maxDate.getFullYear()}-${this.maxDate.getMonth()}-${this.maxDate.getDate()}`;
		let y = `${this.minDate.getFullYear()}-${this.minDate.getMonth()}-${this.minDate.getDate()}`;
		console.log(this.candidate.birth_date);
		if (this.candidate.birth_date > x || this.candidate.birth_date < y){
			this.errorMsg('يرجى ادخال تاريخ حقيقي','خطأ في تاريخ الولادة');
			return;
		}
		this.candidate.nationality_id = this.candidate.nationality?.id
		this.candidate.sec_nationality_id = this.candidate.sec_nationality?.id
		this.candidate.address_country_id = this.candidate.address_country?.id

		if (this.candidate.address_country?.country_code != 'SY')
			this.candidate.address_city_id = null;

		if (this.candidate.address_tel_1?.length > 14)
			this.candidate.address_tel_1 = this.candidate.address_tel_1.slice(0, 14);
		if (this.candidate.address_mob_1?.length > 14)
			this.candidate.address_mob_1 = this.candidate.address_mob_1.slice(0, 14);
		this.isLoading = true;
		this.candidatesService.update(this.candidate, this.authService.user.candidate?.id).subscribe((res: any) => {
			this.isLoading = false;
			this.getCandidateInfo(true, "Update User Info");
			if (type == 'personal_info')
				this.activeIds = ['add_info'];
			else if (type == 'add_info')
				this.activeIds = ['p_exp'];
			else if (type == 'edu')
				this.activeIds = ['edu'];
		}, (error: any) => {
			this.isLoading = false;

			this.errorMsg(error.statusText, "Update User Info");
		});
	}

	deleteProfessionalExp(event) {
		this.candidatesService.deleteProfExp(this.authService.user.candidate?.id, event).subscribe((res: any) => { this.getCandidateInfo(true, "Delete Professional Experience"); });
	}

	editProfessionalExp(event) {
		const modalRef = this.modalService.open(ProfessionalExperienceModalComponent);
		if (!event.skills)
			event.skills = [];
		if (event.company == null)
			event.company = event.company_name;
		for (var i = 0; i < event.skills.length; i++) {
			event.skills[i] = { ...event.skills[i], ...event.skills[i].skill }
		}
		console.log(event)
		modalRef.componentInstance.porfExp = event;
		modalRef.componentInstance.isEdit = true;
		modalRef.result.then((result) => { }).catch((error) => {

		});
		modalRef.componentInstance.notifyParent.subscribe((result) => {
			this.getCandidateInfo(true, "Update Professional Experience");
		})
	}

	deleteEducation(event) {
		this.candidatesService.deleteEducation(this.authService.user.candidate?.id, event).subscribe((res: any) => { this.getCandidateInfo(true, "Delete Education"); });
	}

	editEducation(event) {
		const modalRef = this.modalService.open(EducationModalComponent);
		if (event.major == null)
			event.major = event.major_name;
		if (event.institute == null)
			event.institute = event.institute_name;
		modalRef.componentInstance.Education = event;
		modalRef.componentInstance.isEdit = true;
		modalRef.result.then((result) => { }).catch((error) => {

		});
		modalRef.componentInstance.notifyParent.subscribe((result) => {
			this.getCandidateInfo(true, "Edit Education");
		})
	}

	deleteReference(event) {
		this.candidatesService.deleteReference(this.authService.user.candidate?.id, event).subscribe((res: any) => { this.getCandidateInfo(true, "Delete Reference"); });
	}

	editReference(event) {
		const modalRef = this.modalService.open(ReferencesModalComponent);
		if (event.company == null)
			event.company = event.company_name;
		modalRef.componentInstance.reference = event;
		modalRef.componentInstance.isEdit = true;
		modalRef.result.then((result) => { }).catch((error) => {

		});
		modalRef.componentInstance.notifyParent.subscribe((result) => {
			this.getCandidateInfo(true, "Edit Reference");
		})
	}

	deleteLanguage(event) {
		this.candidatesService.deleteLanguage(this.authService.user.candidate?.id, event).subscribe((res: any) => { this.getCandidateInfo(true, "Delete Language"); });
	}

	editLanguage(event) {
		const modalRef = this.modalService.open(LanguageModalComponent);
		modalRef.componentInstance.language = event;
		modalRef.componentInstance.isEdit = true;
		modalRef.result.then((result) => { }).catch((error) => {

		});
		modalRef.componentInstance.notifyParent.subscribe((result) => {
			this.getCandidateInfo(true, "Edit Language");
		})
	}

	deleteProfCert(event) {
		this.candidatesService.deleteProfCert(this.authService.user.candidate?.id, event).subscribe((res: any) => { this.getCandidateInfo(true, "Delete Professional Certificate"); });
	}

	editProfCert(event) {
		const modalRef = this.modalService.open(ProfessionalCertificatesModalComponent);
		modalRef.componentInstance.profCert = event;
		modalRef.componentInstance.isEdit = true;
		modalRef.result.then((result) => { }).catch((error) => {

		});
		modalRef.componentInstance.notifyParent.subscribe((result) => {
			this.getCandidateInfo(true, "Edit Professional Certificate");
		})
	}

	deleteVoluntary(event) {
		this.candidatesService.deleteVoluntary(this.authService.user.candidate?.id, event).subscribe((res: any) => { this.getCandidateInfo(true, "Delete Voluntary Work"); });
	}

	editVoluntary(event) {
		const modalRef = this.modalService.open(VoluntaryModalComponent);
		modalRef.componentInstance.voluntary = event;
		modalRef.componentInstance.isEdit = true;
		modalRef.result.then((result) => { }).catch((error) => {

		});
		modalRef.componentInstance.notifyParent.subscribe((result) => {
			this.getCandidateInfo(true, "Edit Voluntary Work");
		})
	}

	deleteInterest(event) {
		this.candidatesService.deleteInterest(this.authService.user.candidate?.id, event).subscribe((res: any) => { this.getCandidateInfo(true, "Delete Field Of Interest"); });
	}

	editInterest(event) {
		const modalRef = this.modalService.open(InterestModalComponent);
		modalRef.componentInstance.Interest = event;
		modalRef.componentInstance.isEdit = true;
		modalRef.result.then((result) => { }).catch((error) => {

		});
		modalRef.componentInstance.notifyParent.subscribe((result) => {
			this.getCandidateInfo(true, "Edit Field Of Interest");
		})
	}

	calculateProgressbarProp(isUpdate = false) {
		if (isUpdate)
			setTimeout(() => { this.updateUserProfile('edu'); }, 1000);
		this.fill_level = 0;
		// 40%
		if (this.candidate.first_name && this.candidate.father_name && this.candidate.last_name)
			this.fill_level += 5;
		if (this.candidate.ar_first_name && this.candidate.ar_father_name && this.candidate.ar_last_name)
			this.fill_level += 5;
		if (this.candidate.gender && this.candidate.maritial_status && this.candidate.nationality)
			this.fill_level += 5;
		if (this.candidate.birth_place && this.candidate.birth_date && this.candidate.identity_type)
			this.fill_level += 5;
		if (this.candidate.military_service || this.candidate.gender == 'f') //&& this.candidate.notice_period 
			this.fill_level += 5;

		if (this.candidate.address_country && this.candidate.address_city) //&& this.candidate.notice_period 
			this.fill_level += 5;

		if (this.candidate.address_tel_1 && this.candidate.address_mob_1)
			this.fill_level += 5;

		if (this.candidate.address_details)
			this.fill_level += 5;

		//50%
		if (this.candidate.professional_experience.length > 0 || this.candidate.is_professional_experience)
			this.fill_level += 9;

		//60%
		if (this.candidate.education.length > 0)
			this.fill_level += 9;

		//70%
		if (this.candidate.languages.length > 0)
			this.fill_level += 9;

		//80%
		if (this.candidate.professional_certificate.length > 0)
			this.fill_level += 9;

		//90%
		if (this.candidate.voluntary.length > 0)
			this.fill_level += 9;

		//100%
		if (this.candidate.references.length > 0)
			this.fill_level += 9;
		//100%
		if (this.candidate.references.length > 0)
			this.fill_level += 6;

		if (this.fill_level < 50 && this.fill_level > 0) {
			this.progressColor = "danger";
		}
		else if (this.fill_level < 75 && this.fill_level >= 50) {
			this.progressColor = "warning";
		}
		else if (this.fill_level >= 75) {
			this.progressColor = "success";
		}
	}

	getCandidateInfo(showToast = false, title = "") {
		this.isProfileLoading = true;
		this.candidatesService.get(this.authService.user.candidate?.id).subscribe((res: any) => {
			this.initLoading = false;
			this.isProfileLoading = false;
			this.candidate = res.data;
			if (!showToast)
				this.getCurrentTab();
			if (this.candidate.image_path != null)
				this.img_file = this.candidate.image_path;
			if (showToast)
				this.successMsg("Candidate Profile Information Updated Successfully", title);
			this.calculateProgressbarProp();
			this.setmaxLength();
		}, (error: any) => {
			this.isProfileLoading = false;
			this.initLoading = false;
			this.errorMsg(error?.error?.error, "User Profile");
		});
	}

	getCurrentTab() {
		if (!this.isGenerarlInfo())
			this.activeIds = ["p_info"];
		else if (!this.isAddressInfo())
			this.activeIds = ["add_info"];
		else if (this.candidate.professional_experience.length == 0 && !this.candidate.is_professional_experience)
			this.activeIds = ["p_exp"];
		else if (this.candidate.education.length == 0)
			this.activeIds = ["edu"];
		else if (this.candidate.professional_certificate.length == 0)
			this.activeIds = ["p_cert"];
		else if (this.candidate.voluntary.length == 0)
			this.activeIds = ["voluntary"];
		else if (this.candidate.languages.length == 0)
			this.activeIds = ["lang"];
		else if (this.candidate.field_of_interests.length == 0)
			this.activeIds = ["IT"];
		else if (this.candidate.references.length == 0)
			this.activeIds = ["ref"];
	}

	isGenerarlInfo() {
		if (this.candidate.first_name != null && this.candidate.father_name != null && this.candidate.last_name != null &&
			this.candidate.ar_first_name != null && this.candidate.ar_father_name != null && this.candidate.ar_last_name != null &&
			this.candidate.gender != null && this.candidate.maritial_status != null && this.candidate.nationality != null &&
			this.candidate.birth_place != null && this.candidate.birth_date != null && this.candidate.identity_type != null &&
			(this.candidate.gender == 'f' || this.candidate.military_service != null))
			return true;
		return false;
	}

	isAddressInfo() {
		if (this.candidate.address_country != null && this.candidate.address_details != null &&
			this.candidate.address_tel_1 != null && this.candidate.address_mob_1 != null && this.candidate.address_details != null)
			return true;
		return false;
	}

	isBeginner() {
		var _result = false;
		//&& this.candidate.notice_period != null 
		if (this.candidate.first_name != null && this.candidate.father_name != null && this.candidate.last_name != null &&
			this.candidate.ar_first_name != null && this.candidate.ar_father_name != null && this.candidate.ar_last_name != null &&
			this.candidate.gender != null && this.candidate.maritial_status != null && this.candidate.nationality != null &&
			this.candidate.birth_place != null && this.candidate.birth_date != null && this.candidate.identity_type != null &&
			(this.candidate.gender == 'f' || this.candidate.military_service != null) &&
			this.candidate.address_country != null && this.candidate.address_details != null &&
			this.candidate.address_tel_1 != null && this.candidate.address_mob_1 != null && this.candidate.address_details != null) {
			_result = true;
		}
		return _result;
	}

	openFile() {
		document.querySelector('input').click();
	}

	handle(event) {
		if (event.target.files && event.target.files[0]) {
			if (event.target.files[0].size > 524288)
				return this.errorMsg("Image file is too big, image maximum size is 0.5 MB", "Image Uploading ...");
			this.fileChanged = true;
			this.candidate_image = event.target.files[0];
			var reader = new FileReader();

			reader.readAsDataURL(event.target.files[0]); // read file as data url

			reader.onload = (event) => { // called once readAsDataURL is completed
				this.img_file = reader.result as string;
				this.uploadImage();
			}
		}
	}

	uploadImage() {
		this.isImageLoading = true;
		let formData: FormData = new FormData();
		formData.append("image", this.candidate_image);
		formData.append("user_id", this.authService.user.candidate?.id);
		this.candidatesService.uploadImage(formData, this.authService.user.candidate?.id).subscribe((res: any) => {
			this.isImageLoading = false;
			this.getCandidateInfo(true, "Upload User Image");
			this.fileChanged = false;
		}, (error: any) => {
			this.isImageLoading = false;
			this.errorMsg(error.statusText, "Upload User Image");
			this.fileChanged = false;
		});
	}

	successMsg(message: string, title: string) {
		this.toastr.success(message, title);
	}

	errorMsg(message: string, title: string) {
		this.toastr.error(message, title);
	}

	checkSubmition(type) {
		if (this.isLoading)
			return false;

		if (type == 'L1') {
			if (this.candidate.gender == 'm')
				return this.candidate.first_name && this.candidate.father_name && this.candidate.last_name && this.candidate.mother_name && this.candidate.ar_first_name && this.candidate.ar_father_name && this.candidate.ar_last_name && this.candidate.gender && this.candidate.nationality && this.candidate.birth_place && this.candidate.birth_date && this.candidate.military_service_reason;
			return this.candidate.first_name && this.candidate.father_name && this.candidate.last_name && this.candidate.mother_name && this.candidate.ar_first_name && this.candidate.ar_father_name && this.candidate.ar_last_name && this.candidate.gender && this.candidate.nationality && this.candidate.birth_place && this.candidate.birth_date;
		} else
			return this.candidate.address_country && this.candidate.address_tel_1 && this.candidate.address_mob_1 && this.candidate.address_details;
	}

	setmaxLength() {
		if (this.candidate.identity_type == 'personal_id') {
			this.identity_minlength = 11;
			this.identity_maxlength = 11;
		}
		else {
			this.identity_maxlength = 30;
			this.identity_minlength = 5;
		}
	}

	generateRefID() {
		if (!this.candidate.has_image)
			this.errorMsg("Please upload your profile picture first!", "Generate Application ID");
		else {
			this.isProfileLoading = true;
			this.candidatesService.generateID(this.authService.user.candidate?.id).subscribe((res: any) => {
				this.isProfileLoading = false;
				this.getCandidateInfo(true, "Update User Info");
			}, (error: any) => {
				this.isProfileLoading = false;
				this.errorMsg(error.statusText, "Update User Info");
			});
		}
	}

	getClass(status) {
		switch (status) {
			case "closed":
				return "badge rounded-pill bg-warning"
				break;
			case "rejected":
				return "badge rounded-pill bg-danger"
				break;
			case "processing":
				return "badge rounded-pill bg-accepted"
				break;
		}
	}

	navigate(route) {
		//this.router.navigate([]);
		if (route == 'user-profile')
			this.viewVacancies = false;
		else
			this.viewVacancies = true;
	}

	getTabIcon(tabId) {
		const finishedIcon = "fa fa-check-circle-o";
		const missingIcon = "fa fa-info";
		switch (tabId) {
			case "p_info":
				return finishedIcon;
				break;
			case "add_info":
				return finishedIcon;
				break;
			case "p_exp":
				return this.candidate.professional_experience.length > 0 || this.candidate.is_professional_experience ? finishedIcon : missingIcon;
				break;
			case "edu":
				return this.candidate.education.length > 0 ? finishedIcon : missingIcon;
				break;
			case "p_cert":
				return this.candidate.professional_certificate.length > 0 ? finishedIcon : missingIcon;
				break;
			case "voluntary":
				return this.candidate.voluntary.length > 0 ? finishedIcon : missingIcon;
				break;
			case "lang":
				return this.candidate.languages.length > 0 ? finishedIcon : missingIcon;
				break;
			case "IT":
				return this.candidate.field_of_interests?.length > 0 ? finishedIcon : missingIcon;
				break;
			case "ref":
				return this.candidate.references.length > 0 ? finishedIcon : missingIcon;
				break;
		}
	}

	sendActivationLink() {
		this.isActivationLoading = true;
		this.candidatesService.activateEmail(this.authService.user.candidate?.id).subscribe((res: any) => {
			this.toastr.success("Kindly check your mail inbox", "Activate Account");
			this.isActivationLoading = false;
		}, (error: any) => {
			this.isActivationLoading = false;
			this.toastr.error("You'r Email is not valid Or try again later!", "Activate Account");
		});
	}
}
